
const SELECTS_TEXTS = {
    SEARCH: gettext('Search'),
    EDIT: gettext('edit'),
    DELETE: gettext('delete'),
};

export default SELECTS_TEXTS;
